<template>
  <div class="container prescription-medicine-print">
    <b-overlay :show="loading" opacity="0.99">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
        <v-btn class="btn-print" @click="print"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
      <table
        v-for="group_prescription_medicine in group_prescription_medicines"
        :key="group_prescription_medicine.id"
        class="table table-sm bg-white"
      >
        <tbody class="report-content">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="row">
              <div
                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex align-items-center"
              >
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div
                class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 d-flex align-items-center"
              >
                <img
                  v-if="group_prescription_medicine.resident_photo_url"
                  class="resident_photo_url"
                  :src="group_prescription_medicine.resident_photo_url"
                />
                <img
                  v-if="!group_prescription_medicine.resident_photo_url"
                  class="resident_photo_url"
                  :src="require('../../../assets/user.png')"
                />
                <div class="ml-1">
                  <h6 class="mb-0">
                    {{ group_prescription_medicine.resident_name }}
                  </h6>
                  <h6 class="legends mb-1 worksansr">
                    Data de nascimento:
                    {{
                      formatDate(
                        group_prescription_medicine.resident_date_of_birth,
                        false
                      )
                    }}
                    -
                    {{
                      getAge(group_prescription_medicine.resident_date_of_birth)
                    }}
                    anos
                  </h6>
                  <h6 class="legends mb-1 worksansr">
                    Data de admissão:
                    {{
                      formatDate(
                        group_prescription_medicine.resident_date_of_reception,
                        false
                      )
                    }}
                  </h6>
                  <h6
                    class="legends mb-1 worksansr"
                    v-if="group_prescription_medicine.resident_bed_id"
                  >
                    Leito Nº:
                    {{ group_prescription_medicine.bed_number }}, Andar:
                    {{ group_prescription_medicine.bed_walk }}, ALA/Setor:
                    {{ group_prescription_medicine.bed_ward_or_sector }},
                    Quarto:
                    {{ group_prescription_medicine.bed_bedroom }}
                  </h6>
                </div>
              </div>
              <div
                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex align-items-center justify-content-end"
              >
                <div>
                  <img class="logo" :src="logo" width="180" />

                  <h6
                    v-if="group_prescription_medicine.finish_date"
                    class="text-right pr-5 pt-5 worksansr upper-text"
                  >
                    Data:
                    {{
                      formatDate(group_prescription_medicine.finish_date, false)
                    }}
                  </h6>
                </div>
              </div>
            </div>
            <h6 class="title-one mb-0 text-center">
              Prescrição Médica - Validade
              <span class="color-blue">{{
                formatDate(group_prescription_medicine.start_date, false)
              }}</span>
              até
              <span class="color-blue">{{
                formatDate(group_prescription_medicine.end_date, false)
              }}</span>
            </h6>
            <h6
              class="legends worksansr text-center"
              v-if="
                group_prescription_medicine.group_prescription_medicine_has_general_information &&
                group_prescription_medicine
                  .group_prescription_medicine_has_general_information.length >
                  0
              "
            >
              <p class="m-0">INFORMAÇÕES GERAIS</p>
              <span
                v-for="information in group_prescription_medicine.group_prescription_medicine_has_general_information"
                :key="information.id"
              >
                {{ information.description }};
              </span>
            </h6>
          </div>
          <div class="bg-light p-1">
            <h6 class="mb-0 upper-text">Medicamentos</h6>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
            v-for="(
              item, key_medicine
            ) in group_prescription_medicine.prescription_medicines"
            :key="key_medicine"
          >
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
              >
                <div class="name">
                  <h6 class="mb-0">{{ item.medicine_name }}</h6>
                  <h6 class="legends worksansr mb-0">
                    {{ item.medicine_active_ingredient }}
                  </h6>
                  <h6
                    class="color-deleted text-thirteen check-text-center"
                    v-if="item.prescription_medicine_status == 'EXCLUIDO'"
                  >
                    MEDICAMENTO EXCLUIDO NO DIA
                    {{ formatDate(item.updated_at, false) }}.
                    <br />
                    <span>
                      NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                      {{ formatDate(item.end, false) }}!</span
                    >
                  </h6>
                  <h6
                    class="color-edit text-thirteen check-text-center"
                    v-if="item.edited == 1"
                  >
                    MEDICAMENTO EDITADO NO DIA
                    {{ formatDate(item.edited_date, false) }}.
                    <br />
                    <span class="color-deleted">
                      NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                      {{ formatDate(item.end, false) }}!
                    </span>
                  </h6>
                  <p class="mt-0 mb-0" v-if="item.init">
                    Medicamento inicia:
                    {{ formatDate(item.init, false) }}
                  </p>
                  <p
                    class="mt-0 mb-0"
                    v-if="
                      item.prescription_medicine_status == 'EXCLUIDO' &&
                      item.end_medicine
                    "
                  >
                    Medicamento termina:
                    {{ formatDate(item.end_medicine, false) }}
                  </p>
                  <p
                    class="mt-0 mb-0"
                    v-if="item.edited == 1 && item.end_medicine"
                  >
                    Medicamento termina:
                    {{ formatDate(item.end_medicine, false) }}
                  </p>
                  <p class="mt-2">
                    Cadastrado: {{ formatDate(item.created_at, false) }}
                    <br />
                    Última alteração:
                    {{ formatDate(item.updated_at, false) }}
                  </p>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <h6 class="legends worksansr mb-0" v-if="item.medicine_list">
                  LISTA: {{ item.medicine_list }}
                </h6>
                <h6 class="legends worksansr mb-0">
                  Via de administração:
                  {{ item.route_of_administration_name }}
                </h6>
                <h6 class="legends worksansr mb-0">
                  Frequência: {{ handleFrequency(item.frequency) }}
                </h6>
                <h6
                  v-if="item.frequency != 'EVENTUAL'"
                  class="legends worksansr mb-0"
                >
                  Repetição:
                  {{ handleEvery(item.every, item.frequency) }}
                </h6>
                <h6
                  v-if="item.frequency == 'SEMANAL'"
                  class="legends worksansr mb-0"
                >
                  Dias da semana:
                  {{ item.dom && "DOM" }}
                  {{ item.seg && "SEG" }}
                  {{ item.ter && "TER" }}
                  {{ item.qua && "QUA" }}
                  {{ item.qui && "QUI" }}
                  {{ item.sex && "SEX" }}
                  {{ item.sab && "SAB" }}
                </h6>
                <h6
                  v-if="
                    item.frequency != 'EVENTUAL' &&
                    item.medicine_amount_of_times_name
                  "
                  class="legends worksansr mb-0"
                >
                  Quantidade diária:
                  {{ item.medicine_amount_of_times_name }}
                </h6>
                <strong v-if="item.medicine_amount_of_times_type == 'SHIFTS'">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>TURNO</th>
                          <th>QUANTIDADE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="item.dawn && item.dawn_quantity">
                          <td>MADRUGADA</td>
                          <td>
                            {{
                              item.drops_dawn_quantity
                                ? `${item.drops_dawn_quantity} GOTA(S)`
                                : item.ui_dawn_quantity
                                ? `${item.ui_dawn_quantity} UI`
                                : item.dawn_quantity
                            }}
                            {{
                              item.drops_dawn_quantity
                                ? ""
                                : item.ui_dawn_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.morning && item.morning_quantity">
                          <td>MANHÃ</td>
                          <td>
                            {{
                              item.drops_morning_quantity
                                ? `${item.drops_morning_quantity} GOTA(S)`
                                : item.ui_morning_quantity
                                ? `${item.ui_morning_quantity} UI`
                                : item.morning_quantity
                            }}
                            {{
                              item.drops_morning_quantity
                                ? ""
                                : item.ui_morning_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.afternoon && item.afternoon_quantity">
                          <td>TARDE</td>
                          <td>
                            {{
                              item.drops_afternoon_quantity
                                ? `${item.drops_afternoon_quantity} GOTA(S)`
                                : item.ui_afternoon_quantity
                                ? `${item.ui_afternoon_quantity} UI`
                                : item.afternoon_quantity
                            }}
                            {{
                              item.drops_afternoon_quantity
                                ? ""
                                : item.ui_afternoon_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.night && item.night_quantity">
                          <td>NOITE</td>
                          <td>
                            {{
                              item.drops_night_quantity
                                ? `${item.drops_night_quantity} GOTA(S)`
                                : item.ui_night_quantity
                                ? `${item.ui_night_quantity} UI`
                                : item.night_quantity
                            }}
                            {{
                              item.drops_night_quantity
                                ? ""
                                : item.ui_night_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.shift_5 && item.shift_5_quantity">
                          <td>5º</td>
                          <td>
                            {{
                              item.drops_shift_5_quantity
                                ? `${item.drops_shift_5_quantity} GOTA(S)`
                                : item.ui_shift_5_quantity
                                ? `${item.ui_shift_5_quantity} UI`
                                : item.shift_5_quantity
                            }}
                            {{
                              item.drops_shift_5_quantity
                                ? ""
                                : item.ui_shift_5_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.shift_6 && item.shift_6_quantity">
                          <td>6º</td>
                          <td>
                            {{
                              item.drops_shift_6_quantity
                                ? `${item.drops_shift_6_quantity} GOTA(S)`
                                : item.ui_shift_6_quantity
                                ? `${item.ui_shift_6_quantity} UI`
                                : item.shift_6_quantity
                            }}
                            {{
                              item.drops_shift_6_quantity
                                ? ""
                                : item.ui_shift_6_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.shift_7 && item.shift_7_quantity">
                          <td>7º</td>
                          <td>
                            {{
                              item.drops_shift_7_quantity
                                ? `${item.drops_shift_7_quantity} GOTA(S)`
                                : item.ui_shift_7_quantity
                                ? `${item.ui_shift_7_quantity} UI`
                                : item.shift_7_quantity
                            }}
                            {{
                              item.drops_shift_7_quantity
                                ? ""
                                : item.ui_shift_7_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.shift_8 && item.shift_8_quantity">
                          <td>8º</td>
                          <td>
                            {{
                              item.drops_shift_8_quantity
                                ? `${item.drops_shift_8_quantity} GOTA(S)`
                                : item.ui_shift_8_quantity
                                ? `${item.ui_shift_8_quantity} UI`
                                : item.shift_8_quantity
                            }}
                            {{
                              item.drops_shift_8_quantity
                                ? ""
                                : item.ui_shift_8_quantity
                                ? ""
                                : `${item.unit_of_measurement_abbreviation} (S)`
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <br />
                </strong>
                <h6
                  v-if="
                    item.frequency != 'EVENTUAL' &&
                    (item.duration == 'ATE_A_DATA' ||
                      item.duration == 'DURANTE_UM_PERIODO')
                  "
                  class="legends worksansr mb-0"
                >
                  Data de início:
                  {{ formatDate(item.start_date, false) }}
                </h6>
                <h6
                  v-if="item.frequency != 'EVENTUAL'"
                  class="legends worksansr mb-0"
                >
                  Duração:
                  {{ handleDuration(item.duration) }}
                </h6>
                <h6
                  v-if="
                    item.frequency != 'EVENTUAL' &&
                    item.duration == 'DURANTE_UM_PERIODO'
                  "
                  class="legends worksansr mb-0"
                >
                  Período de:
                  {{ item.duration_time }} dia(s)
                </h6>
                <h6
                  v-if="
                    item.frequency != 'EVENTUAL' &&
                    item.duration == 'ATE_A_DATA'
                  "
                  class="legends worksansr mb-0"
                >
                  Data de término:
                  {{ formatDate(item.end_date, false) }}
                </h6>
                <h6
                  v-if="
                    item.medicine_amount_of_times_type == 'DAY' ||
                    item.frequency == 'EVENTUAL'
                  "
                  class="legends worksansr mb-0"
                >
                  Quantidade:
                  {{
                    item.drops_quantity
                      ? `${item.drops_quantity} GOTA(S)`
                      : item.ui_quantity
                      ? `${item.ui_quantity} UI`
                      : item.quantity
                  }}
                  {{
                    item.drops_quantity
                      ? ""
                      : item.ui_quantity
                      ? ""
                      : `${item.unit_of_measurement_name} (S)`
                  }}
                </h6>
                <h6
                  v-if="
                    item.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'
                  "
                  class="btn-pendent mb-1 mt-2 center-text inline-display"
                >
                  CONTROLE ESPECIAL
                </h6>
                <h6 class="legends worksansr mb-0" v-if="item.instruction">
                  Instrução:
                  {{ item.instruction }}
                </h6>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
                Horário(s)
                <p
                  class="m-0 worksansr"
                  v-for="(time, key_time) in item.prescription_medicine_time"
                  :key="`${time.id}-${key_time}`"
                >
                  {{
                    time.time
                      ? String(time.time).substring(
                          0,
                          String(time.time).length - 3
                        )
                      : "Não informado"
                  }}
                </p>
              </div>
            </div>
            <hr class="mb-0 mt-0 border-black" />
          </div>
        </tbody>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div
            v-if="
              group_prescription_medicine.finish_user &&
              group_prescription_medicine.status != 'INATIVO'
            "
            class="d-flex justify-content-end align-items-center"
          >
            <img
              :class="[
                'mr-2',
                group_prescription_medicine.finish_user.photo_url
                  ? 'user-photo-url'
                  : 'no-user-photo-url',
              ]"
              :src="
                group_prescription_medicine.finish_user.photo_url
                  ? group_prescription_medicine.finish_user.photo_url
                  : require('../../../assets/user.png')
              "
            />
            <small>
              Prescrição finalizada por
              {{
                professionalClassCouncilValue({
                  id: group_prescription_medicine.finish_user
                    .professional_class_council_id,
                  name: group_prescription_medicine.finish_user.name,
                  value:
                    group_prescription_medicine.finish_user
                      .professional_class_council_value,
                  cpf: group_prescription_medicine.finish_user.cpf,
                  office: group_prescription_medicine.finish_user.office,
                })
              }}
              - {{ formatDate(group_prescription_medicine.updated_at) }},
              <p v-if="group_prescription_medicine.status == 'FINALIZADO'">
                <span>
                  {{
                    group_prescription_medicine.certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}</span
                >
                <span
                  v-if="group_prescription_medicine.certificate"
                  class="ml-1 v-clean"
                  >{{ group_prescription_medicine.certificate }}</span
                >.
              </p>
            </small>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5 text-center"
          >
            <hr class="border-black" />
            Gerado por
            {{
              professionalClassCouncilValue({
                id: user.professional_class_council_id,
                name: user.name,
                profile: user.profile_name,
                cpf: user.cpf,
                office: user.office,
                value: user.professional_class_council_value,
              })
            }}
            <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
          </div>
        </div>
      </table>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
        <v-btn class="btn-print" @click="print"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { userData } from "../../../lib/functions";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { getAge } from "../../../lib/getAgeByDate";

import api from "../../../services/api";

import routes from "../../../routes";

import moment from "moment";

export default {
  name: "Print",
  data() {
    return {
      ids: [],
      user: {},
      group_prescription_medicines: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    userData,
    formatDate,
    professionalClassCouncilValue,
    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },
    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
    async retrieve() {
      let { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      let { ids } = routes.history.current.params;

      this.ids = ids.split(",");

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        const { ids } = this;

        var params = {
          ids,
        };

        const response = await api.get(
          "/rest-home/group-prescription-medicine/prints",
          {
            params,
          }
        );

        const { error, errors, group_prescription_medicines } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.group_prescription_medicines = group_prescription_medicines;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      window.print();
    },
  },
};
</script>

<style>
table.report-container {
  width: 100%;
  page-break-inside: avoid;
}
thead.report-header {
  display: table-header-group;
}
tfoot.report-footer {
  display: table-footer-group;
}
.prescription-medicine-print .logo {
  height: 50px;
  object-fit: contain;
}
.prescription-medicine-print .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.prescription-medicine-print .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}
.prescription-medicine-print .medicine .capsule {
  width: 20px;
}

.prescription-medicine-print .medicine .name {
  margin-left: 10px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
}
.prescription-medicine-print .medicine .frequency {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-end;
}
.prescription-medicine-print .medicine .frequency strong {
  font-size: 18px;
}
.prescription-medicine-print li {
  list-style-type: none;
}
@media print {
  .prescription-medicine-print button {
    display: none;
  }
  .prescription-medicine-print li {
    list-style-type: none;
  }
}
</style>
